import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './loginForm'
import HomePage from './home'
import Leaves from './pages/leaves';
import Attendance from './pages/attendance';


const StudentApp = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/leaves" element={<Leaves />} />
        <Route path="/student/attendance" element={<Attendance />} />
      </Routes>
    </div>
  );
};

export default StudentApp;